<div class="flex items-baseline max-xs:items-center max-xs:w-full">
  <i class="icon-glyph-service-time mr-[8px]" [hidden]="hideClock"></i>
  <span class="mr-[8px] font-normal" data-test-id="appointment-service-duration">{{ duration | time }}</span>
  •
  <span class="text-[14px] font-bold uppercase ml-[8px]" data-test-id="appointment-service-price">{{ price | formatMoney }}</span>
</div>
